export const FAIR_LANDING_PATH = '/fair';
export const DEFAULT_LANDING_PATH = '/dashboard';

/**
 * Where an authenticated user belongs.
 *
 * UpFresh customers (`show_only_fair_module`, set by the API when
 * `platform === UP_FRESH`) only have the Beursmodule, so they go straight to
 * it — except when no fair is running, because `FairContainer` bounces them
 * back to the dashboard and the trip would be wasted.
 *
 * Both places that send an authenticated user somewhere read this: the
 * post-authentication saga (`sagas/securitySagas`) and the guard that pushes
 * logged-in users off the login form (`components/Routes/SecurityRoute`).
 * They race on the password flow, so they have to agree.
 *
 * Returns the dashboard when `userDetails` has not loaded yet, which is the
 * pre-existing behaviour for every non-fair user.
 */
export const getLandingPath = (userDetails) =>
    userDetails?.show_only_fair_module === true &&
    userDetails?.is_fair_active === true
        ? FAIR_LANDING_PATH
        : DEFAULT_LANDING_PATH;
